import { render, staticRenderFns } from "./viewEvent.vue?vue&type=template&id=4a76a7f5&scoped=true&"
import script from "./viewEvent.vue?vue&type=script&lang=js&"
export * from "./viewEvent.vue?vue&type=script&lang=js&"
import style0 from "./viewEvent.vue?vue&type=style&index=0&id=4a76a7f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a76a7f5",
  null
  
)

export default component.exports